import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import philosophyImage from '../Photos/Phil_img.jpg';
import philosophyImage_avif from '../Photos/Phil_img.avif';
import philosophyImage_webp from '../Photos/Phil_img.webp';
import productImage1_avif from '../Photos/Product - Grouse Satin.avif';
import productImage1_webp from '../Photos/Product - Grouse Satin.webp';
import productImage1 from '../Photos/Product - Grouse Satin.jpg';
import productImage2_avif from '../Photos/Product - NFX.avif';
import productImage2_webp from '../Photos/Product - NFX.webp';
import productImage2 from '../Photos/Product - NFX.jpg';
import productImage3_avif from '../Photos/Product- NFP.avif';
import productImage3_webp from '../Photos/Product- NFP.webp';
import productImage3 from '../Photos/Product- NFP.jpg';
import WhatsAppButton from '../Components/WhatsAppButton';

function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
      <main>
        {/* Hero Section */}
        <section className="hero-bg relative min-h-screen flex items-start justify-center pt-12">
          {/* Overlay */}
          <div className="absolute inset-0 bg-black opacity-60"></div>
          <div className="relative z-5 text-center px-4">
            <h1 className="font-montserrat text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tighter text-white">
              Building cornerstones since <span className="accent-red">1969</span>
            </h1>
            <p className="mt-4 max-w-2xl mx-auto text-sm sm:text-lg md:text-xl lg:text-2xl text-neutral-300">
              Experience you can build on. We craft durable, high-quality clay bricks for any design.
            </p>
            <a href="#products" className="mt-8 inline-block bg-accent-red text-white font-bold uppercase tracking-widest py-3 px-6 sm:px-8 rounded-sm hover:bg-red-700 transition-colors duration-300">
              Explore Collections
            </a>
          </div>
        </section>
  
        {/* Featured Products Section */}
        <section id="products" className="py-16 sm:py-28">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <h2 className="font-montserrat text-2xl sm:text-4xl md:text-5xl font-bold">Featured Collections</h2>
              <div className="mt-2 mx-auto h-1 w-20 bg-accent-red"></div>
            </div>
            
            {/* Product Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              
              {/* Product Card 1 */}
              <div className="group bg-zinc-800 rounded-sm overflow-hidden border border-zinc-700 flex flex-col">
                <div className="overflow-hidden">
                  <Link to="/product-grouse-satin">
                  <picture>
                    <source srcSet={productImage1_avif} type="image/avif" />
                    <source srcSet={productImage1_webp} type="image/webp" />
                    <img src={productImage1} alt="FBA - Grouse Satin" className="w-full h-64 sm:h-72 object-cover card-img" onError="this.onerror=null;this.src='https://placehold.co/600x400/101010/F5F5F5?text=Image+Not+Found';"/>
                  </picture>
                </Link>
                </div>
                <div className="p-6 flex flex-col flex-grow">
                  <h3 className="font-montserrat text-xl sm:text-2xl font-bold">FBA - Grouse Satin</h3>
                  <p className="mt-2 text-neutral-400 flex-grow">Clay bricks that are selected or produced for their durability and aesthetic effect deriving from non-uniformity of size, shape, or colour</p>
                  <Link to="/product-grouse-satin" className="mt-4 inline-block bg-accent-red text-white font-bold uppercase tracking-widest py-3 px-6 rounded-sm hover:bg-red-700 transition-colors duration-300 text-center">Learn More</Link>
                </div>
              </div>
                
              {/* Product Card 2 */}
              <div className="group bg-zinc-800 rounded-sm overflow-hidden border border-zinc-700 flex flex-col">
                <div className="overflow-hidden">
                  <Link to="/product-nfx">
                  <picture>
                    <source srcSet={productImage2_avif} type="image/avif" />
                    <source srcSet={productImage2_webp} type="image/webp" />
                    <img src={productImage2} alt="NFX" className="w-full h-64 sm:h-72 object-cover card-img" onError="this.onerror=null;this.src='https://placehold.co/600x400/251D1B/F5F5F5?text=Image+Not+Found';"/>
                  </picture>
                </Link>
                </div>
                <div className="p-6 flex flex-col flex-grow">
                  <h3 className="font-montserrat text-xl sm:text-2xl font-bold">NFX Range</h3>
                  <p className="mt-2 text-neutral-400 flex-grow">Clay bricks suitable for use, plastered or unplastered, for general building work below damp-proof course or under damp conditions or below ground level where durability rather than aesthetics is the criterion for selection.</p>
                  <Link to="/product-nfx" className="mt-4 inline-block bg-accent-red text-white font-bold uppercase tracking-widest py-3 px-6 rounded-sm hover:bg-red-700 transition-colors duration-300 text-center">Learn More</Link>
                </div>
              </div>
              
              {/* Product Card 3 */}
              <div className="group bg-zinc-800 rounded-sm overflow-hidden border border-zinc-700 flex flex-col">
                <div className="overflow-hidden">
                  <Link to="/product-nfp">
                  <picture>
                    <source srcSet={productImage3_avif} type="image/avif" />
                    <source srcSet={productImage3_webp} type="image/webp" />
                    <img src={productImage3} alt="NFP Brick" className="w-full h-64 sm:h-72 object-cover card-img" onError="this.onerror=null;this.src='https://placehold.co/600x400/3C3C3C/F5F5F5?text=Image+Not+Found';"/>
                  </picture>
                </Link>
                </div>
                <div className="p-6 flex flex-col flex-grow">
                  <h3 className="font-montserrat text-xl sm:text-2xl font-bold">NFP Range</h3>
                  <p className="mt-2 text-neutral-400 flex-grow">NFP clay bricks are suitable for general building work that is to be plastered.</p>
                  <Link to="/product-nfp" className="mt-4 inline-block bg-accent-red text-white font-bold uppercase tracking-widest py-3 px-6 rounded-sm hover:bg-red-700 transition-colors duration-300 text-center">Learn More</Link>
                </div>
              </div>
  
            </div>
          </div>
        </section>
        
        {/* About / Philosophy Section */}
        <section id="about" className="bg-zinc-900 py-16 sm:py-28">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <picture>
                  <source srcSet={philosophyImage_avif} type="image/avif" />
                  <source srcSet={philosophyImage_webp} type="image/webp" />
                  <img src={philosophyImage} alt="Close-up of brick texture" className="rounded-sm w-full object-cover"/>
                </picture>
              </div>
              <div className="text-center lg:text-left">
                <h2 className="font-montserrat text-2xl sm:text-4xl md:text-5xl font-bold">The Art of Clay</h2>
                <div className="mt-2 h-1 w-20 bg-accent-red mx-auto lg:mx-0"></div>
                <p className="mt-6 text-md sm:text-lg text-neutral-300 leading-relaxed">
                  We believe that a brick is more than a building material; it is the fundamental unit of architectural vision. Our process is a fusion of traditional craftsmanship and industrial technology, ensuring every single unit meets exacting standards of form, function, and durability.
                </p>
                <p className="mt-4 text-md sm:text-lg text-neutral-300 leading-relaxed">
                  From the selection of raw clay to the final firing, we control every variable to create products of unparalleled consistency and character. This is our commitment to the architects and builders who demand nothing less than perfection.
                </p>
              </div>
            </div>
          </div>
        </section>
        <WhatsAppButton />
      </main>
    );
}

export default HomePage;